/**
 * NotificationStatusBar — FCM/SMS channel status, permission banner, VAPID guide.
 */
import React from 'react';

export default function NotificationStatusBar({
  notifPerm, fcmReady, fcmError, smsEnabled, setSmsEnabled,
  requestPermission, sendAlert,
}) {
  return (
    <div className="ai__notif-status-bar">
      {notifPerm === 'default' && (
        <div className="ai__notif-banner">
          <span>🔔 Enable push notifications to get real-time alerts on your phone even when this tab is closed</span>
          <button className="ai__notif-btn" onClick={requestPermission}>Enable Notifications</button>
        </div>
      )}
      {notifPerm === 'denied' && (
        <div className="ai__notif-banner ai__notif-banner--denied">
          <span>🔕 Browser notifications are blocked. Enable in browser settings, or use SMS-only alerts below.</span>
        </div>
      )}

      <div className="ai__notif-channels">
        <div className={`ai__notif-channel ${fcmReady ? 'ai__notif-channel--ok' : 'ai__notif-channel--off'}`}>
          <span className="ai__notif-channel-icon">{fcmReady ? '📲' : '📵'}</span>
          <div>
            <div className="ai__notif-channel-name">Push Notifications</div>
            <div className="ai__notif-channel-sub">
              {fcmReady
                ? 'Active — alerts delivered to this device even when browser is closed'
                : fcmError === 'no_vapid_key'
                ? 'Needs VAPID key setup — see setup guide below'
                : fcmError === 'permission_denied'
                ? 'Permission denied — enable in browser settings'
                : 'Click "Enable Notifications" to activate'}
            </div>
          </div>
          {!fcmReady && notifPerm !== 'denied' && (
            <button className="ai__notif-btn" onClick={requestPermission}>Enable</button>
          )}
        </div>

        <div className={`ai__notif-channel ${smsEnabled ? 'ai__notif-channel--ok' : 'ai__notif-channel--off'}`}>
          <span className="ai__notif-channel-icon">{smsEnabled ? '💬' : '🔇'}</span>
          <div>
            <div className="ai__notif-channel-name">SMS to +19376540871</div>
            <div className="ai__notif-channel-sub">
              {smsEnabled
                ? 'Active — critical alerts sent via Twilio (needs TWILIO_* env vars in Vercel)'
                : 'Disabled — toggle to re-enable'}
            </div>
          </div>
          <button
            className={`ai__notif-toggle ${smsEnabled ? 'ai__notif-toggle--on' : ''}`}
            onClick={() => setSmsEnabled(v => !v)}
          >{smsEnabled ? 'On' : 'Off'}</button>
        </div>

        <button
          className="ai__test-notif-btn"
          onClick={() => sendAlert(
            'test_' + Date.now(),
            '🧪 Test Alert',
            'This is a test notification from Desi Bites AI. If you see this on your phone, notifications are working!',
            'high'
          )}
        >
          📤 Send Test Notification
        </button>
      </div>

      {!fcmReady && (
        <details className="ai__vapid-guide">
          <summary>🔧 FCM Push Setup Guide (one-time, 3 steps)</summary>
          <ol className="ai__vapid-steps">
            <li>Go to <a href="https://console.firebase.google.com/project/desibitesweb/settings/cloudmessaging" target="_blank" rel="noreferrer">Firebase Console → Project Settings → Cloud Messaging</a></li>
            <li>Under <strong>Web Push certificates</strong>, click <strong>Generate Key Pair</strong>. Copy the public key.</li>
            <li>In <a href="https://vercel.com" target="_blank" rel="noreferrer">Vercel</a> → Project → Settings → Environment Variables, add:<br />
              <code>REACT_APP_FCM_VAPID_KEY</code> = <em>the key you copied</em><br />
              Then redeploy.
            </li>
          </ol>
        </details>
      )}
    </div>
  );
}
